module.exports = [
    {
        id: 'vero',
        answers: [
            { value: 1, name: 'Veronkorotukset', },
            { value: -1, name: 'Leikkaukset', },
        ],
    },
    {
        id: 'lande',
        answers: [
            { value: -1, name: 'Ei', },
            { value: 1, name: 'Kyllä', },
        ],
    },
    {
        id: 'ymparisto',
        answers: [
            { value: 1, name: 'Ympäristö', },
            { value: -1, name: 'Talouskasvu', },
        ],
    },
    {
        id: 'monikulttuuri',
        answers: [
            { value: -1, name: 'Ei', },
            { value: 1, name: 'Kyllä', },
        ],
    },
    {
        id: 'eu',
        answers: [
            { value: -1, name: 'Ei', },
            { value: 1, name: 'Kyllä', },
        ],
    },
    {
        id: 'ahvenanmaa',
        answers: [
            { value: -1, name: 'Ei', },
            { value: 1, name: 'Kyllä', },
        ],
    },
    {
        id: '420',
        answers: [
            { value: -1, name: 'Ei', },
            { value: 1, name: 'Kyllä', },
        ],
    },
]
